import { Producto, Productos } from '@/interface/producto.model';
import { Component } from '@angular/core';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: ['./productos.component.scss']
})
export class ProductosComponent {
  rows: Array<Producto>;
  tempRows: Array<Producto>;

  constructor(
    public generalService: GeneralService,
    private toastr: ToastrService,
    private loadingService: LoadingService) { }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.loadingService.setLoading(true)
    this.generalService.getListar("producto/all")
      .then(res => {
        this.rows = res.data;
        this.tempRows = res.data;
        this.loadingService.setLoading(false)
      })
      .catch(err => {
        console.log(err)
        this.loadingService.setLoading(false)
      })

  }
}
